import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ChooseLocationEffects } from './choose-location.effects';
import { IChooseLocationFeature } from './choose-location.feature.state';
import { ChooseLocationReducer } from './choose-location.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IChooseLocationFeature>('ChooseLocationFeature'), ChooseLocationReducer),
    EffectsModule.forFeature([ChooseLocationEffects]),
  ],
})
export class ChooseLocationStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ChooseLocationStateModule
  ) {
    if (parentModule) {
      throw new Error('ChooseLocationStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
